// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + (chunkId === 363 ? "wix-payment-methods-banner-demo" : chunkId) + ".chunk.min.js";
};